/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForecast = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15.816 4.067a3.523 3.523 0 0 1 1.368 0l.388-1.962a5.522 5.522 0 0 0-2.144 0zm-2.227 1.489c.256-.382.585-.711.967-.967l-1.113-1.662a5.524 5.524 0 0 0-1.516 1.516zm4.855-.967c.382.256.711.585.967.967l1.662-1.113a5.524 5.524 0 0 0-1.516-1.516zm1.489 2.227c.044.22.067.449.067.684v1.125h2V7.5a5.52 5.52 0 0 0-.105-1.072zM13 7.5c0-.235.023-.464.067-.684l-1.962-.388A5.52 5.52 0 0 0 11 7.5v1.125h2zm0 3.5h-2v5.5a3.5 3.5 0 1 1-7 0V12H2v4.5a5.5 5.5 0 1 0 11 0zm7 0v2h2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgForecast as Forecast };
